import TextInput from "./TextInput";
import SelectInput from "./SelectInput";
import { LabeledCell } from "./PatientSection";
import { FIELD_STATE, isRequiredFieldState } from "../../utils";

const StructureSection = ({ admission, activeFields, laboratories, onAdmissionChange, ProcessingStatusIcon }) => {
  const isMissing = (state, filled) => isRequiredFieldState(state) && !filled;
  const shouldShowSection =
    activeFields?.admission?.silReservationNumber !== FIELD_STATE.DISABLE ||
    activeFields?.admission?.silAdmissionNumber !== FIELD_STATE.DISABLE ||
    activeFields?.admission?.establishment !== FIELD_STATE.DISABLE ||
    admission?.laboratory?._id;

  if (shouldShowSection !== true) return null;

  return (
    <div className="mb-4">
      <div className="mb-2">
        <div className="section-title">
          <span>Structure</span>
          <ProcessingStatusIcon type="LABORATORY" />
        </div>
      </div>
      <div className="card relative overflow-hidden">
        <div className="grid grid-cols-4 divide-x divide-gray-100">
          <div className="p-4">
            <LabeledCell label="Laboratoire">
              <SelectInput
                value={admission?.laboratory?._id}
                onChange={(event) => {
                  const nextLaboratoryId = event.target.value;
                  if (window.confirm("Voulez-vous vraiment changer le laboratoire de cette admission ?") === false) return;
                  onAdmissionChange([{ field: "laboratory._id", value: nextLaboratoryId }]);
                }}
                options={laboratories.map((laboratory) => ({ value: laboratory._id, label: laboratory.name }))}
                placeholder="Laboratoire"
              />
            </LabeledCell>
          </div>
          <div className="p-4">
            {activeFields?.admission?.establishment !== FIELD_STATE.DISABLE ? (
              <LabeledCell label="Établissement" dataFocusField="establishment" attention={isMissing(activeFields?.admission?.establishment, !!admission?.establishment)}>
                <TextInput
                  fieldState={activeFields?.admission?.establishment}
                  value={admission?.establishment}
                  onChange={(event) => onAdmissionChange([{ field: "establishment", value: event.target.value }])}
                  placeholder="—"
                />
              </LabeledCell>
            ) : null}
          </div>
          <div className="p-4">
            {activeFields?.admission?.silReservationNumber !== FIELD_STATE.DISABLE ? (
              <LabeledCell label="N° de réservation" dataFocusField="silReservationNumber" attention={isMissing(activeFields?.admission?.silReservationNumber, !!admission?.silReservationNumber)}>
                <TextInput
                  fieldState={activeFields?.admission?.silReservationNumber}
                  value={admission?.silReservationNumber}
                  onChange={(event) => onAdmissionChange([{ field: "silReservationNumber", value: event.target.value }])}
                  placeholder="—"
                />
              </LabeledCell>
            ) : null}
          </div>
          <div className="p-4">
            {activeFields?.admission?.silAdmissionNumber !== FIELD_STATE.DISABLE ? (
              <LabeledCell label="N° dossier SIL" dataFocusField="silAdmissionNumber" attention={isMissing(activeFields?.admission?.silAdmissionNumber, !!admission?.silAdmissionNumber)}>
                <TextInput
                  fieldState={activeFields?.admission?.silAdmissionNumber}
                  value={admission?.silAdmissionNumber}
                  onChange={(event) => onAdmissionChange([{ field: "silAdmissionNumber", value: event.target.value }])}
                  placeholder="—"
                />
              </LabeledCell>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StructureSection;
